"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    ManagePermissions: "permissions",
    Hire: "hire",
    Terminate: "terminate",
    AnnouncementNotifications: "announcement-notifications",
    CoIAccess: "coi-access"
};
